import React from "react";
import { Stack, Typography, FormControlLabel } from "@mui/material";
import CameraAlt from "@mui/icons-material/CameraAlt";
import { CustomSwitch } from "./CustomSwitch";

const ImageVideoToggle = ({
  imageToggle,
  setImageToggle,
  updateCheckedBoxes,
}) => {
  const handleToggle = (e) => {
    const checked = e.target.checked;
    updateCheckedBoxes("ImageVideoAvailable", {
      name: "ImageVideoAvailable",
      checked: checked ? "Y" : "N",
    });
    setImageToggle(checked);
  };

  return (
    <Stack direction="row" spacing={1} sx={{ marginLeft: "15rem" }}>
      <FormControlLabel
        control={
          <CustomSwitch
            id="ImageVideoAvailable"
            type="checkbox"
            sx={{ marginLeft: "1rem" }}
            checked={imageToggle}
            onClick={handleToggle}
          />
        }
        label={
          <Typography
            variant="body3"
            sx={{ fontWeight: "800", marginLeft: "2rem" }}
          >
            Image/Video Available <CameraAlt color="primary" />
          </Typography>
        }
      />
    </Stack>
  );
};

export default ImageVideoToggle;
